import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import ClientDashboard from "@/pages/ClientDashboard";
import PublicCard from "@/pages/PublicCard";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";

const TOAST_OPTIONS = {
  style: {
    background: "#101B28",
    border: "1px solid #1E2D40",
    color: "#ffffff",
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin-portal/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Navigate to="/admin-portal/login" replace />} />
            <Route
              path="/admin-portal/dashboard"
              element={
                <ProtectedRoute role="admin" redirectTo="/admin-portal/login">
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/client/dashboard"
              element={
                <ProtectedRoute role="client" redirectTo="/login">
                  <ClientDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/card/:slug" element={<PublicCard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" toastOptions={TOAST_OPTIONS} />
    </div>
  );
}

export default App;